<template>
  <custom-dialog
    :title="$t('fms_cancel_payment_dialog.che_xiao_fu_kuan')"
    width="1500px"
    :visible="visible"
    :append-to-body="true"
    v-on="$listeners"
    class="cancel-payment-dialog"
  >
    <div class="dialog-body">
      <div class="info-container">
        <div class="l">
          <bill-container :title="$t('fms_cancel_payment_dialog.zhang_dan_lie_biao')">
            <accounts-registration-accounts-bill
              v-model="billList"
              :orderNum="getPaymentCode(registerMsg)"
              ref="payableBill"
              :tips="false"
              :auth="[]"
              :paymentOrReceivable="true"
            ></accounts-registration-accounts-bill>
          </bill-container>
          <bill-container :title="$t('fms_cancel_payment_dialog.fu_kuan_xin_xi')">
            <accounts-registration-msg-bill
              v-model="tradeList"
              :outerItem="firstOrderItem"
              ref="msgBill"
              :orderNum="getPaymentCode(registerMsg)"
              :payableTotal="payableTotal"
              :billInfo="registerMsg"
              :auth="[]"
              :expandFlowMsg="false"
              :paymentOrReceivable="true"
            ></accounts-registration-msg-bill>
          </bill-container>
        </div>
        <div class="r">
          <div class="pay-info">
            <div class="title">{{ $t('fms_cancel_payment_dialog.fu_kuan_xiang_qing') }}</div>
            <div class="order-code">
              <div class="label">{{ $t('fms_cancel_payment_dialog.ding_dan_bian_hao') }}:</div>
              <div class="value">{{getPaymentCode(registerMsg)}}</div>
            </div>
            <div class="order-code">
              <div class="label">{{ $t('fms_cancel_payment_dialog.shou_kuan_fang') }}:</div>
              <div class="value">{{firstOrderItem.receivableOrgName}}</div>
            </div>
            <div class="group-list">
              <div class="group">
                <div class="amount">
                  <div class="should-pay"><span class="bold">{{ $t('fms_cancel_payment_dialog.shi_fu_he_ji') }}：</span>￥{{actualPayAmount}}</div>

                  <div class="details">
                    <div class="item">
                      <div class="key">{{ $t('fms_cancel_payment_dialog.zu_lin_yu_e') }}</div>
                      <div class="val">￥{{expectUseRest}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_cancel_payment_dialog.dui_gong_zhuan_zhang') }}</div>
                      <div class="val">￥{{publicAmount}}</div>
                    </div>
                    <div class="item">
                      <div class="key">{{ $t('fms_cancel_payment_dialog.xian_jin_zhi_fu') }}</div>
                      <div class="val">￥{{cashAmount}}</div>
                    </div>
                  </div>

                  <div class="should-pay expect-rest"><span class="bold">{{ $t('fms_cancel_payment_dialog.ying_shou_he_ji') }}：</span>￥{{payableTotal}}</div>
                  <div
                    class="should-pay"
                    v-if="thisRest"
                  ><span class="bold">{{ $t('fms_cancel_payment_dialog.ben_ci_jie_yu') }}：</span>￥{{thisRest}}</div>
                  <div class="should-pay mt-15">{{ $t('fms_cancel_payment_dialog.fu_kuan_cao_zuo_ren') }}：{{paymentConfirmUser || '-'}}</div>
                  <div class="should-pay">{{ $t('fms_cancel_payment_dialog.fkczsj') }}：{{paymentConfirmTime || '-'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div
      class="dialog-footer"
      slot="footer"
    >
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="cancelPayment"
      >{{ $t('fms_cancel_payment_dialog.che_xiao_fu_kuan') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 撤销付款 */

import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';
import commonDialogMixin from './dialogMixin';
import billContainer from './bill_container';
import accountsRegistrationAccountsBill from './accounts_registration_accounts_bill';
import accountsRegistrationMsgBill from './accounts_registration_msg_bill';
import mixins from './mixins';

export default {
  name: '',
  mixins: [dialogMixins, commonDialogMixin, mixins],
  components: {
    billContainer,
    accountsRegistrationAccountsBill,
    accountsRegistrationMsgBill,
  },
  props: {
    // model: {
    //   data: {
    //     // 选中的rows
    //     // billData: []
    //   }
    // }
  },
  data() {
    return {
      registerMsg: {
        balance: '',
        deposit: '',
        billPaymentCode: '',
      },
      // 应付款账单信息
      billList: [],
      // 付款信息
      tradeList: [],
      userType: [],
      firstOrderItem: {},
      orderViewList: [],
      useRest: false,
    };
  },
  computed: {
    // 操作人: paymentConfirmUser
    paymentConfirmUser() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return billPayment.paymentConfirmUser;
    },
    // 操作时间：paymentConfirmTime
    paymentConfirmTime() {
      let billPayment = {};
      if (this.registerMsg && this.registerMsg.billPayment) {
        billPayment = this.registerMsg.billPayment;
      }
      return this.$momentLocal(billPayment.paymentConfirmTime);
    },
    // 本次结余 实付金额-应付金额，若本次结余为0时不显示此行）
    thisRest() {
      const actualPayAmount = this.actualPayAmount || 0;
      const payableTotal = this.payableTotal || 0;
      return Math.max(actualPayAmount - payableTotal, 0);
    },
    payableTotal() {
      return this.billList.reduce((total, item) => {
        const { paymentAmount = 0 } = item;
        const sum = paymentAmount;
        return sum + total;
      }, 0);
    },
    // 实付金额
    actualPayAmount() {
      const expectUseRest = this.expectUseRest || 0;
      const total = this.total || 0;
      return expectUseRest + total;
    },
    balance() {
      return this.registerMsg.balance;
    },
    total() {
      const key = 'totalAmount';
      const list = this.tradeList;
      return list.reduce((total, item) => total + Number(item[key] || 0), 0);
    },
    // 预计使用余额
    expectUseRest() {
      const payableTotal = this.payableTotal || 0;
      const tradeTotal = this.total || 0;
      const balance = this.useRest ? this.balance || 0 : 0;
      const ret = payableTotal - tradeTotal >= balance ? balance : payableTotal - tradeTotal;
      return Math.max(ret, 0);
    },
    // 对公转账
    publicAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.public_account}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
    // 现金支付
    cashAmount() {
      const list = this.tradeList;
      if (this.dicMap.payment_class) {
        const ret = list.filter(item => `${item.tradeMethod}` === `${this.dicMap.payment_class.cash}`);
        return ret.reduce((total, item) => {
          const { totalAmount = 0 } = item;
          return total + Number(totalAmount);
        }, 0);
      }
      return 0;
    },
  },
  watch: {},
  filters: {},
  directives: {},
  methods: {
    closeDialog() {
      this.visible = false;
    },
    onCancel() {
      this.closeDialog();
    },
    // 撤销付款
    cancelPayment() {
      this.$showConfirm(this.$t('fms_cancel_payment_dialog.nqdydxzdzdkdzdyjcxfk')).then(() => {
        const billPaymentCode = this.getPaymentCode(this.registerMsg);
        const url = `${apis.paymentRevoke}/${billPaymentCode}`;
        this.$postJSON(url, {}, true).then(() => {
          this.$message({
            type: 'success',
            message: this.$t('Common.com_handle_success')
          });
          this.$emit('success');
          this.closeDialog();
        });
      });
    },
    getReqData() {
      // portal-应付租金和isynergy-应付租金,isynergy-应付总部中，应付账款列表要做数据合并（后端没有做押金数据的组包）
      // const path = this.$route.path;
      // const pattern = new RegExp('/deviceBill/payRental');
      // const pattern2 = new RegExp('/pay/rental');
      // const pattern3 = new RegExp('/pay/factoryAccount');
      // const hasMerge = pattern.test(path) || pattern2.test(path) || pattern3.test(path);
      return {
        // balanceAmount: this.$refs.msgBill.getRest(),
        // depositAmount: this.$refs.msgBill.getDeposit(),
        // finalPayment: this.$refs.msgBill.getTotal('totalAmount'),
        // paymentAmount: this.$refs.payableBill.getTotal('paymentAmount'),
        billPaymentCode: this.getPaymentCode(this.registerMsg),
        paymentCode: this.getPaymentCode(this.registerMsg),
        billList: this.billList,
        tradeList: this.tradeList,
        useBalance: this.$refs.msgBill.isUseRest(),
        payableOrgName: this.firstOrderItem.payableOrgName,
        payableOrgId: this.firstOrderItem.payableOrgId,
      };
    },
    getPageInfo() {
      const firstItem = this.billList[0];
      const url = this.getPaymentInfoReqUrl(firstItem);
      this.$getJSON(url).then((res) => {
        const data = res.data;
        this.registerMsg = data;
        this.registerMsg.balance = this.getBalance(data);
        this.registerMsg.deposit = this.registerMsg.deposit || 0;
        if (data.orderViewList && data.orderViewList.length) {
          this.billList = data.orderViewList;
        }
        if (data.tradeBoList && data.tradeBoList.length) {
          data.tradeBoList.forEach((item) => {
            item.attachs = [];
            this.$getJSON(`${apis.OssAttach}/${item.tradeId}/fms.trade.certificate`).then((imgRes) => {
              item.attachs = imgRes.data;
            });
          });
          this.tradeList = data.tradeBoList;
        }
        if (data.billPayment && data.billPayment.isUseBalance) {
          this.useRest = true;
        }
        // if (data.billPayment && data.billPayment.isUseBalance) {
        //   this.$refs.msgBill.selRest();
        // }
      });
    },
  },
  created() { },
  mounted() {
    this.getDicMap('payment_class');
    this.billList = this.model.data.billData;
    this.firstOrderItem = this.billList[0];
    this.getPageInfo();
    // this.getRegisterMsg();
  },
};
</script>

<style lang="scss">
.cancel-payment-dialog {
  .bold {
    font-weight: bold;
  }
  .expect-rest {
    margin-top: 24px;
  }
  .mt-15{
    margin-top: 15px;
  }
  .info-container {
    display: flex;
    .l {
      flex: 1;
      padding-right: 20px;
    }

    .r {
      width: 350px;

      .pay-info {
        .item {
          overflow: hidden;
          &:nth-child(n + 2) {
            margin-top: 4px;
          }
          .key {
            float: left;
            font-size: 12px;
            color: #4d4d4d;
            line-height: 18px;
          }
          .val {
            overflow: hidden;
            font-size: 12px;
            color: #1a1a1a;
            line-height: 18px;
            padding-left: 16px;
            white-space: normal;
          }
        }
      }

      .pay-info {
        background: #fff;
        padding: 10px;
        border: 1px solid whitesmoke;
        border-radius: 4px;
        overflow: hidden;
        border-top: 4px solid #00a0d9;

        > .title {
          line-height: 30px;
          font-size: 14px;
          margin-bottom: 10px;
          font-weight: bold;
        }

        .order-code {
          color: #4d4d4d;
          font-size: 14px;
          line-height: 20px;
          margin-bottom: 10px;
          overflow: hidden;

          .label {
            float: left;
          }
          .value {
            overflow: hidden;
            padding-left: 16px;
          }
        }

        .group {
          padding: 24px 0;
          border-top: 1px solid rgba(245, 245, 245, 1);

          // &:last-child {
          //   border-bottom: 1px solid rgba(245, 245, 245, 1);
          // }
        }

        .rest {
          overflow: hidden;
          line-height: 20px;
          .label {
            font-size: 14px;
            float: left;
            color: #4d4d4d;
          }
          .value {
            float: left;
            font-size: 14px;
            color: #1a1a1a;
            padding-left: 16px;
          }
          .use-rest {
            float: right;
            .use-label {
              float: left;
              color: #4d4d4d;
            }
            .use-cb {
              float: left;
              margin-left: 10px;
            }
          }
        }

        .amount {
          .should-pay {
            line-height: 24px;
            color: #4d4d4d;
            font-size: 14px;
          }

          .details {
            background: rgba(248, 249, 250, 1);
            padding: 16px;
            margin-top: 16px;
            .item {
              line-height: 20px;
              font-size: 14px;
              overflow: hidden;
              &:nth-child(n + 2) {
                margin-top: 12px;
              }
              .key {
                color: #4d4d4d;
                float: left;
              }
              .val {
                color: #1a1a1a;
                float: right;
              }
            }
          }

          .actual-pay {
            overflow: hidden;
            line-height: 24px;
            font-size: 14px;
            margin-top: 20px;
            .key {
              float: left;
              color: #1a1a1a;
            }
            .val {
              float: left;
              color: #00a0d9;
            }
          }
        }

        .btn-content {
          padding-top: 24px;
          padding-bottom: 10px;

          .btn {
            display: block;
            width: 100%;
            margin-left: 0 !important;
            &:nth-child(n + 2) {
              margin-top: 24px;
            }
          }
        }
      }
    }
  }
}
</style>
